<template>
  <div class="top-[130px] left-4 flex w-full shrink-0 items-center">
    <section
      v-if="
        isAppLoading || isFetchingBoards || boards.length > 0 || hasPlanInvites || hasInvitations
      "
      data-test="main-instance-control-block"
      class="bg-agentnoon-primary-700 mr-4 flex h-9 items-center rounded-lg p-1 pr-1.5 shadow-lg"
    >
      <p class="mr-2 ml-1.5 text-sm text-white">Instance</p>
      <BoardSelection />
    </section>

    <div class="relative flex-1">
      <PopperTooltip
        v-if="isAgentnoonAccount"
        content="Add instance"
        placement="bottom"
        hover
        open-delay="300"
        :disabled="showInstanceOptions"
        style="border-width: 0; margin: 0"
      >
        <button
          v-if="isAgentnoonAccount"
          class="instance-options-toggle hover:text-bluedark-700 flex items-center justify-center text-sm font-medium text-gray-500 transition-colors"
          @click="toggleInstanceOptions"
        >
          <div
            class="bg-agentnoon-primary-700 flex h-7 w-7 items-center justify-center rounded-full"
          >
            <PlusIcon class="h-4 w-4 text-white" />
          </div>
        </button>
      </PopperTooltip>
      <ul
        v-if="showInstanceOptions"
        ref="optionsMenu"
        class="absolute top-full left-0 mt-2 rounded-lg border-gray-200 bg-white text-left text-sm shadow-md"
      >
        <li class="w-full">
          <button
            class="group relative flex w-full flex-col gap-4 rounded-lg px-4 py-2.5 text-left whitespace-nowrap hover:bg-gray-50"
            @click="showCreateInstanceModal = true"
          >
            <p class="text-xs text-gray-900">Create new instance</p>
          </button>
        </li>
        <li class="w-full">
          <button
            class="group relative flex w-full flex-col gap-4 rounded-lg px-4 py-2.5 text-left whitespace-nowrap hover:bg-gray-50"
            @click="showCloneInstanceModal = true"
          >
            <p class="text-xs text-gray-900">Clone existing instance</p>
          </button>
        </li>
      </ul>
    </div>

    <CreateBoard :show="showCreateInstanceModal" @close="showCreateInstanceModal = false" />
    <CloneInstance :show="showCloneInstanceModal" @close="showCloneInstanceModal = false" />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import BoardSelection from '@/components/BoardSelection.vue'
import CloneInstance from '@/components/CloneInstance.vue'
import CreateBoard from './CreateBoard.vue'
import { onClickOutside } from '@vueuse/core'
import { PlusIcon } from '@heroicons/vue/outline'
import useBoard from '@/hooks/use-board'
import { isAdminUser } from '@/utils/admin-users'

const { getters } = useStore()
const { boards } = useBoard()

const showCreateInstanceModal = ref(false)
const showCloneInstanceModal = ref(false)
const showInstanceOptions = ref(false)
const optionsMenu = ref(null)

const user = computed(() => getters.user)
const isAgentnoonAccount = computed(() => isAdminUser(user.value?.email))

const isAppLoading = computed(() => getters.isAppLoading)
const isFetchingBoards = computed(() => getters.isFetchingBoards)
const hasInvitations = computed(() => getters.hasPendingInvitations)
const hasPlanInvites = computed(() => getters.hasUserPlanInvites)

onClickOutside(optionsMenu, (event) => {
  // Only close if we're not clicking the toggle button
  if (!event.target.closest('button.instance-options-toggle')) {
    showInstanceOptions.value = false
  }
})

const toggleInstanceOptions = () => {
  showInstanceOptions.value = !showInstanceOptions.value
}
</script>
